import { WorkspaceJobType } from 'generated/graphql'

type JobType = 'briefing' | 'dashboard'

const jobTypeMap: Record<string, JobType> = {
  [WorkspaceJobType.Briefing]: 'briefing',
  [WorkspaceJobType.AutoBriefingSocial]: 'briefing',
  default: 'dashboard',
}

export const mapJobType = (type?: WorkspaceJobType | null): JobType => jobTypeMap[type] || jobTypeMap.default
